import React from 'react';
import QuicklogIntervalTable from '../quicklog/QuicklogIntervalTable';

const PrintQuicklogStriplog = ({ quicklogRows = [], listVisualMaps = null }) => (
  <QuicklogIntervalTable
    quicklogRows={quicklogRows}
    listVisualMaps={listVisualMaps}
    variant="print"
    rowHeightPx={18}
    gridColumns="62px 54px 46px 54px 80px minmax(0, 1fr)"
  />
);

export default PrintQuicklogStriplog;
